import React from 'react';
import classNames from 'classnames';
import { Text } from '@leverege/ui-elements';
import { formatNumber, formatPercent } from '../../../util/Formatting';
import S from './Performance.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function PerformanceComparison({
  currentValue,
  previousValue,
  metricName,
  isPercentage
}) {
  const getPeriodOverPeriodRate = (current, previous, isPercentage) => {
    if (current === 0 && previous === 0) {
      return NaN;
    }
    if (isPercentage) {
      return current - previous;
    }
    return 100 * (current - previous) / previous;
  };
  const formatValue = ({
    value,
    isPercentage,
    showPlusSign
  }) => {
    if (!value && value !== 0) {
      return '-';
    }
    if (value === Infinity) {
      return '+';
    }
    const prefix = showPlusSign && value >= 0 ? '+' : '';
    if (isPercentage) {
      return formatPercent(value, {
        prefix,
        maxDecimals: 1
      });
    }
    return formatNumber(value, {
      prefix
    });
  };
  const getComparisonText = (current, previous, metricName, isPercentage) => {
    const currentValueText = formatValue({
      value: current,
      isPercentage
    });
    const previousValueText = formatValue({
      value: previous,
      isPercentage
    });
    return `(${currentValueText} vs. ${previousValueText} ${metricName})`;
  };
  const periodOverPeriodRate = getPeriodOverPeriodRate(currentValue, previousValue, isPercentage);
  const periodComparisonClass = periodOverPeriodRate > 0 ? S.greenText : S.redText;
  const formattedRate = formatValue({
    value: periodOverPeriodRate,
    isPercentage: true,
    showPlusSign: true
  });
  const comparisonText = getComparisonText(currentValue, previousValue, metricName, isPercentage);
  return /*#__PURE__*/_jsxs("div", {
    className: S.metricContainer,
    children: [/*#__PURE__*/_jsx(Text, {
      className: classNames(S.periodComparisonText, periodComparisonClass),
      children: formattedRate
    }), /*#__PURE__*/_jsx(Text, {
      className: S.metricText,
      children: comparisonText
    })]
  });
}